if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.bindNavigationEvents();
      }

      bindNavigationEvents() {
        // Pulsanti freccia
        const prevBtn = this.querySelector('.product-media-modal__nav--prev');
        const nextBtn = this.querySelector('.product-media-modal__nav--next');
        
        if (prevBtn) prevBtn.addEventListener('click', () => this.navigateMedia(-1));
        if (nextBtn) nextBtn.addEventListener('click', () => this.navigateMedia(1));

        // Tasti freccia tastiera
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.navigateMedia(-1);
          if (e.key === 'ArrowRight') this.navigateMedia(1);
        });

        // Swipe touch
        let touchStartX = 0;
        this.addEventListener('touchstart', (e) => {
          touchStartX = e.touches[0].clientX;
        });
        this.addEventListener('touchend', (e) => {
          const touchEndX = e.changedTouches[0].clientX;
          const diff = touchStartX - touchEndX;
          if (Math.abs(diff) > 50) {
            this.navigateMedia(diff > 0 ? 1 : -1);
          }
        });
      }

      navigateMedia(direction) {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        const activeMedia = this.querySelector('[data-media-id].active');
        const currentIndex = allMedia.indexOf(activeMedia);
        let newIndex = currentIndex + direction;

        // Loop circolare
        if (newIndex < 0) newIndex = allMedia.length - 1;
        if (newIndex >= allMedia.length) newIndex = 0;

        const newMedia = allMedia[newIndex];
        
        // Rimuovi active da tutti
        allMedia.forEach(m => m.classList.remove('active'));
        
        // Aggiungi active al nuovo
        newMedia.classList.add('active');
        newMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        // Carica contenuto se necessario
        const template = newMedia.querySelector('template');
        if (newMedia.nodeName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) {
          newMedia.loadContent();
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
